<div class="close" (click)="close()">{{ 'NGX-MESSAGING.close' | translate }}</div>
<emoji-mart class="emoji-mart" (emojiSelect)="addEmoji($event)" title="Choose your emoji"></emoji-mart>
